// removed by extract-text-webpack-plugin
module.exports = {"checkCell":"_1uvUTAYVbZhjENTRFbRHpq","actionCell":"hZtr9d6v8cPZ38mO1iht","row":"-jq8JRoNLhwXI8A27em1f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupContacts/GroupContactsListItem/GroupContactsListItem.scss
// module id = 1271
// module chunks = 1